import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
Vue.use(Vuex);

const vuexLocal = new VuexPersist({
	storage: window.localStorage,
});
export default new Vuex.Store({
	state: {
		userinfo: {
			token: '',
			user_id: '',
			role: '',
			fname: '',
			fname_roma: '',
			name: '',
			name_roma: '',
			email: '',
			avatar: '',
			coache: '',
			tp_account: '',
			line_signup: '',
			regist_from: '',
			introducer: '',
			profession: '',
			body_condition: ''
		},
		notice_cnt: [],
	},
	mutations: {
		updateUserinfo(state, userinfo) {
			this.state.userinfo = Object.assign(state.userinfo, userinfo);
		},
		updateNoticeCnt(state, notice_cnt) {
			// this.state.notice_cnt = Object.assign(state.notice_cnt, notice_cnt);
			this.state.notice_cnt = notice_cnt;
		}
	},
	actions: {},
	modules: {},
	plugins: [vuexLocal.plugin],
});
